import AgreementDidNotSigned from "./AgreementDidNotSigned";
import AgreementSigned from "./AgreementSigned";
import AuthorizedVendor from "./AuthorizedVendor";
import NewVendor from "./NewVendor";
import Requirements from "./Requirments/Requirments";

export const VendorRoutes = {
    AuthorizedVendor,
    AgreementSigned,
    AgreementDidNotSigned,
    NewVendor,
    Requirements
}